import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from './user.service';
import { FeatureFlagService } from './feature-flag/feature-flag.service';
import { FeatureFlagCollection } from '../../../shared/interfaces/feature-flag.interface';
import { ITenantInfoWithPackageInfo } from '../../../shared/interfaces/tenant.interface';
import { $artificialIntelligence, $tenant } from '../../../shared/constants/tenant';
import { AngularUtility } from '../utility/angular.utility';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class AiService {
  /**
   * If the `artificial_intelligence_optin` Feature Flag is disabled, this will always return `true`.
   *
   * Otherwise, it will check for the `tenant.artificialIntelligence.enabled` property and return `true` if its value is not explicitly set to false.
   */
  public aiEnabledForTenant$: Observable<boolean>;
  constructor(
    private appConfigService: AppConfigService,
    private featureFlagService: FeatureFlagService,
    private userService: UserService,
  ) {
    this.aiEnabledForTenant$ = combineLatest([
      this.featureFlagService.variation$(FeatureFlagCollection.artificialIntelligenceOptin, false),
      this.userService.currentTenant$,
    ]).pipe(
      map(([aiOptInFeatureFlagEnabled, tenant]: [boolean, ITenantInfoWithPackageInfo]): boolean => {
        if (!this.appConfigService.getAiEnabled()) {
          return false;
        }
        if (aiOptInFeatureFlagEnabled === false) {
          return true;
        }
        return tenant?.[$tenant.artificialIntelligence]?.[$artificialIntelligence.enabled] !== false;
      }),
      AngularUtility.shareRef(),
    );
  }
}
